import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase/config';
import { useNavigate } from 'react-router-dom';
import seal from "../assets/Background.png";
import { ChevronLeft } from 'lucide-react';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/console');
        } catch (err) {
            console.error('Login error:', err);
            switch (err.code) {
                case 'auth/invalid-email':
                    setError('Invalid email address.');
                    break;
                case 'auth/user-disabled':
                    setError('This account has been disabled.');
                    break;
                case 'auth/user-not-found':
                    setError('No account found with this email.');
                    break;
                case 'auth/wrong-password':
                    setError('Incorrect password.');
                    break;
                case 'auth/invalid-credential':
                    setError('Invalid email or password.');
                    break;
                default:
                    setError('Failed to log in. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center gap-5 flex-col h-full ">
            <div className="flex items-center gap-5 w-full h-[100vh] flex-col">
                <div className="flex items-center gap-5 mr-auto p-16">
                    <a href="/">
                        <div className="flex items-center gap-0">
                            <ChevronLeft />
                            <p className="font-bold">
                                Home
                            </p>
                        </div>
                    </a>
                </div>

                <div className="bg-white p-10 rounded-[40px] shadow-[0_20px_60px_rgba(0,0,0,0.3)] w-full max-w-[420px] border-[1px] border-gray-200 mb-100">
                    <img src={seal} alt="Seal" className="w-24 h-24 mx-auto mb-6" />
                    <h1 className="text-[28px] font-bold text-[#333] mb-2 text-center">Admin Console</h1>

                    <form onSubmit={handleLogin} className="flex flex-col gap-5 text-left pt-5">
                        <div className="flex flex-col gap-2">
                            <label htmlFor="email" className="text-sm font-semibold text-[#333]">Email</label>
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="px-4 py-3 border-2 border-[#e0e0e0] rounded-lg text-[15px] transition-all duration-200 outline-none focus:border-[#667eea] focus:shadow-[0_0_0_3px_rgba(102,126,234,0.1)] placeholder-[#999]"
                                placeholder="admin@example.com"
                                required
                                autoComplete="email"
                            />
                        </div>

                        <div className="flex flex-col gap-2">
                            <label htmlFor="password" className="text-sm font-semibold text-[#333]">Password</label>
                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="px-4 py-3 border-2 border-[#e0e0e0] rounded-lg text-[15px] transition-all duration-200 outline-none focus:border-[#667eea] focus:shadow-[0_0_0_3px_rgba(102,126,234,0.1)] placeholder-[#999]"
                                placeholder="••••••••"
                                required
                                autoComplete="current-password"
                            />
                        </div>

                        {error && (
                            <div className="bg-[#fee] text-[#c33] px-4 py-3 rounded-lg text-sm border-l-4 border-[#c33]">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="px-3 py-2 bg-black text-white border-none rounded-full text-base font-semibold cursor-pointer transition-all duration-300 mt-2 
                         active:translate-y-0 disabled:opacity-60 disabled:cursor-not-allowed"
                            disabled={loading}
                        >
                            {loading ? 'Signing in...' : 'Sign In'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;


